export default {
      id: "fb-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svgsprite.svg#fb",
      toString: function () {
        return this.url;
      }
    }